export default __webpack_public_path__ + "static/media/NO.783cc4bc.ico";